<template>
    <div class="ourSpaceBG" v-loading="loadingPageTag">
        <el-row>
            <el-col :span="12" :offset="6">
                <el-backtop target=".ourSpaceBG" style="background-color:#ffefef;width:50px;height:50px;"></el-backtop>

                <div class="masterCard masterHidden">
                    <el-row :gutter="20">
                        <el-col :span="24">
                            <el-card class="masterCard masterHidden line2">
                                <el-row>
                                    <el-col class="masterText">
                                        <span class="masterTitle">
                                            记录下今天
                                        </span>
                                    </el-col>
                                </el-row>
                                <el-divider content-position="left">
                                    <span class="person">
                                        {{ this.$userInfo.$userName }}
                                    </span>
                                    <i class="el-icon-date masterDate"></i>
                                    <span class="masterDate">
                                        <span>
                                            {{ nowDate }}
                                        </span>
                                    </span>
                                </el-divider>
                                <el-row>
                                    <el-col :span="16" style="margin-bottom:2vh;">
                                        <el-input v-model="inputTitle" placeholder="今天发生了什么呢" size="default"
                                            maxlength="50" show-word-limit></el-input>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-tooltip content="点击发表" placement="top" effect="light">
                                            <el-button type="primary" size="default" @click="submitUpload"
                                                :disabled="submitPermission" icon="el-icon-chat-line-square" round>
                                                发表一下
                                            </el-button>
                                        </el-tooltip>

                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col>
                                        <el-input type="textarea" size="default" placeholder="记录一下吧" v-model="inputText"
                                            maxlength="500" show-word-limit :autosize="{ minRows: 7, maxRows: 7 }">
                                        </el-input>
                                    </el-col>
                                </el-row>

                                <el-row>
                                    <el-col style="height: 220px;margin-top:2vh;overflow:scroll;">
                                        <span v-if="this.tempFileList.length === 0"
                                            style="font-family:`HMOS_Regular`;color:#ccc">
                                            图片多的时候这里是可以滚动的喔
                                        </span>
                                        <el-upload action="https://api-proxy.yanghaocheng.workers.dev/upload/img" :headers="{
                                            apikey: 'FG8orFhD0x2DWt5T4qgoNhvtXTfX4V'
                                        }" :on-remove="onRemove" name="img" :on-success="onSuccess" :on-error="onError"
                                            :on-exceed="onExceed" :limit="5" list-type="picture-card"
                                            :before-upload="beforeUpload" :auto-upload="true"
                                            :on-preview="handlePictureCardPreview"
                                            style="margin-top:2vh;margin-bottom:2vh;" ref="upload"
                                            :disabled="this.$userInfo.$userLimit !== '1'">
                                            <i class="el-icon-plus"></i>
                                        </el-upload>
                                        <el-dialog :visible.sync="dialogVisible">
                                            <img width="100%" :src="dialogImageUrl" alt="">
                                        </el-dialog>
                                    </el-col>
                                </el-row>


                            </el-card>
                        </el-col>
                    </el-row>
                </div>
            </el-col>

            <el-col :span="12" :offset="6" v-for="item in master" :key="item.master_id">
                <el-card class="masterCard masterHidden">

                    <el-tooltip content="点击关闭这个帖子" placement="bottom" effect="light"
                        v-if="item.person === $userInfo.$userName">
                        <el-button circle size="mini" type="info" class="masterBtn" @click="closeMaster(item)"
                            style="z-index:1">
                        </el-button>
                    </el-tooltip>

                    <el-row>
                        <el-col class="masterText">
                            <span class="masterTitle">
                                {{ item.master_title }}
                            </span>
                        </el-col>
                    </el-row>

                    <el-divider content-position="left">
                        <span class="person">
                            {{ item.person }}
                        </span>
                        <i class="el-icon-date masterDate"></i>
                        <span class="masterDate">
                            {{ item.master_date }}
                        </span>
                    </el-divider>

                    <el-row style="display:flex;margin-bottom:20px;">
                        <el-col :span="24" class="masterContent">
                            {{ item.master_content }}
                        </el-col>
                    </el-row>

                    <el-row :gutter="10">
                        <el-col :span="6" class="masterPic" v-for="pic in item.pics" style="margin-bottom:10px;">
                            <el-image style="width: 11.5vw; height: 11.5vw;display:inline-block;" :src="pic" fit="cover"
                                :preview-src-list="item.pics"></el-image>
                        </el-col>
                    </el-row>

                    <el-divider content-position="left">
                        <i class="el-icon-chat-line-square storyDate"></i>
                        <span class="storyDate" v-if="item.discusses.length !== 0">
                            评论
                        </span>
                        <span class="storyDate" v-else>
                            还没有评论哦，快来评论吧！
                        </span>
                    </el-divider>

                    <div style="position:relative;margin-bottom:10px;" v-for="discuss in item.discusses">
                        <el-tooltip content="点击关闭这条评论" placement="bottom" effect="light">
                            <el-button circle size="mini" type="info" class="discussBtn"
                                @click="closeDiscuss(item, discuss)" style="z-index:1"
                                v-if="discuss.person === $userInfo.$userName">
                            </el-button>
                        </el-tooltip>
                        <el-row>
                            <el-col style="text-align:left;">
                                <span class="discussPerson">
                                    {{ discuss.person }}
                                </span>
                                <span class="discussDate">
                                    {{ $moment(discuss.discuss_date).format('YYYY-MM-DD HH:mm') }}
                                </span>
                            </el-col>
                            <el-col style="text-align:left">
                                <span class="discussContent">
                                    {{ discuss.discuss_content }}
                                </span>
                            </el-col>
                        </el-row>
                    </div>


                    <el-row style="margin-top:20px" :gutter="20">
                        <el-col :span="22">
                            <el-input type="text" placeholder="评论一下吧！" v-model="item.discuss" maxlength="200"
                                show-word-limit size="default">
                            </el-input>
                        </el-col>
                        <el-col :span="2">
                            <el-tooltip content="点击评论" placement="top" effect="light">
                                <el-button type="primary" size="default" @click="submitDiscuss(item)"
                                    icon="el-icon-chat-line-square" circle>
                                </el-button>
                            </el-tooltip>
                        </el-col>
                    </el-row>

                </el-card>



            </el-col>
            <el-col :span="12" :offset="6">
                <el-pagination class="masterHidden" style="margin-top:5vh;margin-bottom:15vh;" background
                    :page-size="pageSize" layout="prev, pager, next" :total="masterTotalCount"
                    @current-change="loadPage" :current-page="masterCurrentPage">
                </el-pagination>
            </el-col>
        </el-row>

    </div>
</template>

<script>
export default {
    name: 'successfulMaster',
    created() {

    },
    data() {
        return {
            loadingPageTag: false,
            countDownTime: '',
            countDownText: '',
            emergencyCountDown: false,
            submitPermission: false,
            tempFileList: [],
            UrlAndImgID: [],
            fileListLength: 0,
            inputText: '',
            inputTitle: '',
            files: [],
            nowDate: "",
            master: [],
            dialogImageUrl: '',
            dialogVisible: false,
            masterTotalCount: 0,
            pageSize: 10,
            masterCurrentPage: 1,
            littlePlan: '',
            plans: [],
            updateCountDownInterval: undefined
        }
    },
    beforeDestroy() {
        if (this.formatDate) {
            clearInterval(this.formatDate);
        }
        if (this.updateCountDownInterval) {
            clearInterval(this.updateCountDownInterval);
        }
    },
    mounted() {
        if (this.$userInfo.$userLimit === '') {
            this.$message({
                message: '不要乱来哦',
                type: 'warning'
            });
            this.$router.push('/noZone');
        } else if (this.$userInfo.$userLimit > '2') {
            this.$message({
                message: '不要乱来哦',
                type: 'warning'
            });
            this.$router.push('/home');
        }

        this.getTotal();
        this.currentTime();
        this.cancelLoading();
        this.loadPage(1);

        this.updateCountDownInterval = setInterval(() => {
            this.$forceUpdate()
        }, 1000)

    },
    methods: {
        closeDiscuss(item, discuss) {
            this.$confirm('确定要关闭这个评论吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let tempDiscussId = discuss.discuss_id
                let _this = this;
                this.$axios({
                    method: 'post',
                    url: this.$baseUrl + '/masters/closeDiscuss',
                    data: {
                        discussId: tempDiscussId
                    }
                }).then((response) => {
                    _this.loadPage(_this.masterCurrentPage);
                    _this.$message({
                        message: '关闭成功',
                        type: 'success'
                    });
                }).catch((err) => {
                    _this.$message({
                        message: '关闭评论时出了点小问题，重试一下',
                        type: 'error'
                    });
                    _this.loadPage(_this.masterCurrentPage);
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '取消关闭'
                });
            });
        },
        submitDiscuss(item) {
            let discussContent = item.discuss;
            if (discussContent === "") {
                this.$message({
                    message: '还没写东西呢',
                    type: 'warning'
                });
                return;
            }
            let itemId = item.master_id;
            item.discuss = '';
            let time = new Date().getTime().toString();
            let tempData = {
                discuss_id: time,
                discuss_content: discussContent,
                person: this.$userInfo.$userName,
                master_id: itemId
            }
            this.$axios({
                method: 'post',
                url: this.$baseUrl + '/masters/uploadDiscuss',
                data: tempData
            }).then((res) => {
                this.$message({
                    message: '评论成功',
                    type: 'success'
                });
                this.loadPage(this.masterCurrentPage);
            }).catch((err) => {
                this.$message({
                    message: '评论时出了点小问题，重试一下',
                    type: 'error'
                });
            });
        },
        closeMaster(item) {
            this.$confirm('确定要关闭这个帖子吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let tempMasterId = item.master_id;
                let _this = this;
                console.log(tempMasterId)
                this.$axios({
                    method: 'post',
                    url: this.$baseUrl + '/masters/closeMaster',
                    data: {
                        masterId: tempMasterId
                    }
                }).then((response) => {
                    _this.loadPage(_this.masterCurrentPage);
                    _this.$message({
                        message: '关闭成功',
                        type: 'success'
                    });
                }).catch((err) => {
                    this.$message({
                        message: '关闭帖子时出了点小问题，重试一下',
                        type: 'error'
                    });
                    this.loadPage(_this.masterCurrentPage);
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '取消关闭'
                });
            });
        },
        refreshObserver() {
            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('masterShow');
                    }
                });
            })
            const hiddenElements = document.querySelectorAll('.masterHidden');
            hiddenElements.forEach((el) => observer.observe(el));
        },
        onExceed(files, fileList) {
            // alert(fileList.length);
            this.$message({
                message: '最多只能上传5张照片',
                type: 'error'
            });
        },
        beforeUpload(file) {
            // alert(file.name);
            this.submitPermission = true;
            let fileType = file.name;
            fileType = fileType.substring(fileType.length - 4).toLowerCase();
            if (fileType !== '.jpg' && fileType !== '.png' && fileType !== '.gif' && fileType !== 'jpeg') {
                this.$message({
                    message: "文件格式有误，请上传jpg、png、gif、jpeg格式的图片",
                    type: 'error'
                });
                this.submitPermission = false;
                return false;
            }
            // alert(file.size);
            if (file.size > 10 * 1024 * 1024) {
                this.$message({
                    message: "文件大小不能超过10MB",
                    type: 'error'
                });
                this.submitPermission = false;
                return false;
            }
        },
        currentTime() {
            setInterval(this.formatDate, 500);
        },
        formatDate() {
            let date = new Date();
            let year = date.getFullYear(); // 年
            let month = date.getMonth() + 1; // 月
            let day = date.getDate(); // 日
            let hour = date.getHours(); // 时
            hour = hour < 10 ? "0" + hour : hour;
            let minute = date.getMinutes(); // 分
            minute = minute < 10 ? "0" + minute : minute;
            let second = date.getSeconds(); // 秒
            second = second < 10 ? "0" + second : second;
            this.nowDate = `${year}-${month}-${day} ${hour}:${minute}`;
        },
        cancelLoading() {
            setTimeout(() => {
                this.loading = false;
            }, 500);
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        submitUpload() {
            if (this.inputTitle === "" || this.inputText === "") {
                this.$message({
                    message: '有东西没写喔',
                    type: 'warning'
                });
                return;
            }
            let title = this.inputTitle;
            let text = this.inputText;
            let list = this.tempFileList;
            let master_data = {
                master_title: title,
                master_content: text,
                img_list: list,
                person: this.$userInfo.$userName
            };
            this.$axios({
                method: 'post',
                url: this.$baseUrl + '/masters/uploadMaster',
                data: master_data
            }).then((response) => {
                this.$message({
                    message: '发表成功',
                    type: 'success'
                });
                this.loadPage(1);
                this.inputTitle = "";
                this.inputText = "";
                this.tempFileList = [];
                this.$refs.upload.clearFiles();
            }).catch((err) => {
                this.$message({
                    message: '发表说说时出现问题，重试一下',
                    type: 'error'
                })
                this.loadPage(1);
                console.log(err);
                this.inputTitle = title;
                this.inputText = text;
                this.tempFileList = list;
            })
        },
        onSuccess(response, file, fileList) {
            console.log(response);
            let temp = {
                file: file,
                url: response.url,
                img_id: response.img_id
            };
            this.tempFileList.push(temp);
            this.submitPermission = false;
            console.log("添加成功")
            console.log(this.tempFileList)
        },
        onError(err, file, fileList) {
            this.$message({
                message: '发生错误',
                type: 'error'
            })
        },
        getTotal() {
            let _this = this;
            this.$axios({
                method: 'get',
                url: this.$baseUrl + "/masters/getTotal",
            })
                .then(function (response) {
                    _this.masterTotalCount = response.data.data[0].total;
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        loadPage(page) {
            this.loadingPageTag = true;
            let _this = this;
            this.$axios({
                method: 'get',
                url: this.$baseUrl + "/masters/getMasterList?page=" + page + "&pageSize=" + this.pageSize,
            })
                .then(function (response) {
                    _this.master = [];
                    for (let item of response.data.data) {
                        item.master_date = _this.$moment(item.master_date).format('YYYY-MM-DD HH:mm')
                        _this.master.push(item);
                    }
                    _this.$nextTick(() => {
                        _this.refreshObserver();
                    })
                    _this.masterCurrentPage = page;
                    _this.loadingPageTag = false;
                })
                .catch(function (error) {
                    console.log(error);
                    _this.loadingPageTag = false;
                });
        },
        onRemove(_file, fileList) {
            let imgId = ''
            for (let i = 0; i < this.tempFileList.length; i++) {
                if (this.tempFileList[i].file === _file) {
                    imgId = this.tempFileList[i].img_id;
                }
            }
            this.tempFileList = this.tempFileList.filter((item) => {
                return item.img_id != imgId;
            });
            this.$axios({
                method: "post",
                url: "http://img.codesocean.top/image/delete_img",
                headers: {
                    apikey: this.$store.state.apikey
                },
                data: {
                    img_id: imgId
                }
            })
            this.tempFileList.splice(this.tempFileList.indexOf(file), 1);
            // console.log("删除成功")
            // console.log(this.tempFileList)
        },

    }
}
</script>


<style scoped lang="scss">
.discussContent {
    display: inline-block;
    text-indent: 30px;
    align-self: center;
    text-align: left;
    margin-top: 10px;
}

.discussPerson {
    font-family: "HMOS_Regular";
    font-size: 18px;
    font-weight: 600;
}

.discussDate {
    font-family: "HMOS_Regular";
    font-size: 10px;
    font-weight: 600;
}

.discussBtn {
    position: absolute;
    right: 20px;
    top: 20px;
}

.storyDate {
    font-family: "HMOS_Regular";
    font-weight: 600;
    font-size: 16px;
}

.person {
    font-family: "HMOS_Regular";
    font-size: 1.8vh;
    color: #ff6363;
}

.countingDown {
    text-align: left;
}

.countingDownText {
    display: inline-block;
    margin-top: 10px;
    font-family: "HMOS_Regular";
    font-weight: 600;
    font-size: 20px;
}

.countDownExtension {
    display: inline-block;
    position: relative;
    top: 4px;
    font-family: "HMOS_Regular";
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
}

.emergencyCountDownExtension {
    color: #ff6363;
    font-family: "HMOS_Regular";
    font-weight: 600;
}

.timerContainer {
    width: 100%;
    height: 460px;
    background: #bfa;
}

.line2 {
    height: 580px !important;
}

.countDownBtn {
    position: absolute;
    right: 20px;
    top: 20px;
}

.masterBtn {
    position: absolute;
    right: 30px;
    top: 30px;
}

.countDownText {
    display: inline-block;
    margin-top: 10px;
    font-family: "HMOS_Regular";
    font-weight: 400;
}

.planText {
    display: inline-block;
    margin-top: 10px;
    font-family: "HMOS_Regular";
    font-weight: 400;
}

.planBtn {
    z-index: 2;
    position: absolute;
    right: 20px;
    top: 20px;
    width: 16px;
    height: 16px;
}

.planFinished {
    color: #6cc441;
}

.planFinishing {
    color: #e6a23c;
}

.planFinished:hover {
    color: #82c460;
    cursor: pointer;
}

.planFinishing {
    color: #e4ac57;
    cursor: pointer;
}

.planExtension {
    display: inline-block;
    position: relative;
    top: 4px;
    font-family: "HMOS_Regular";
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
}

.line1 {
    height: 350px;
}

.el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
}

.el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
}

.zxtMark {
    background-color: transparent;
    color: inherit;
    background-image: linear-gradient(#ff6363, #ff6363);
    background-repeat: no-repeat;
    background-size: 100% 30%;
    background-position: 0 100%;
}

.masterDate {
    font-family: "HMOS_Regular";
    font-weight: 600;
    font-size: 2vh;
}

.masterContent {
    display: inline-block;
    text-indent: 30px;
    align-self: center;
    text-align: left;
}

.masterTitle {
    font-family: "HMOS_Regular";
    font-size: 3vh;
}

.writtenByZxt {
    font-family: "HMOS_Regular";
    font-size: 1.8vh;
    color: #ff6363;
}

.writtenByYxy {
    font-family: "HMOS_Regular";
    font-size: 1.8vh;
    color: #409eff;
}

.masterPic {
    height: auto;
    display: inline-block;
    align-self: center;
}

.masterText {
    height: 100%;
    text-align: left;
}

.masterCard {
    display: inline-block;
    margin: 0 auto;
    width: 100%;
    margin-top: 10px;
    height: auto;
    margin-bottom: 0px;
    text-align: center;
}

.ourSpaceBG {
    /* background-color:#bfa; */
    width: 100%;
    height: 100%;
    text-align: center;
    overflow: auto;
}

.masterBottom {
    text-align: center;
    color: #333;
    height: 100px;
    font-family: "HMOS_Regular"
}

.masterHidden {
    // filter: blur(5px);
    transform: translateY(50%);
    opacity: 0;
    transition: all 1000ms;
}

.masterShow {
    // filter: blur(0);
    transform: translateY(0);
    opacity: 1;
}

::-webkit-scrollbar {
    display: none;
}
</style>